import React, { FC, memo, useCallback, useMemo } from 'react'
import { AsyncSelect } from '@wmgtech/legato'
import { useController } from 'react-hook-form'
import { IAlterAutocomplete } from './AlterNamesTable.props'
import { useChartSearch } from 'modules/ProjectEdit/serviceHooks/useChartSearch'
import debounce from 'lodash/debounce'
import * as Types from 'shared/__gql-types'

export const AlterAutocomplete: FC<IAlterAutocomplete> = memo(({
  placeholder,
  disabled,
  control,
  fieldName,
  onSelect
}) => {
  const { searchChartHandler, chartResult, isLoading } = useChartSearch()
  const { field } = useController({
    name: fieldName,
    control
  })

  const debounceSearch = useMemo(() => debounce(searchChartHandler, 500), [searchChartHandler])
  const onSearchCallback = useCallback((val: string) => {
    onSelect(fieldName, val)
    if (val.replace(/\s/g, '').length >= 3) {
      debounceSearch(fieldName.split('_')[0] as Types.ChartNameTypeParameter, val)
    }
  }, [debounceSearch, onSelect, fieldName])

  const onSelectCallback = useCallback((selected) => {
    onSelect(fieldName, selected?.value)
  }, [onSelect, fieldName])

  return (
    <AsyncSelect
      {...field}
      disabled={disabled}
      list={chartResult}
      getTitle={({ label }) => label}
      getKey={({ value }) => value}
      onSelect={onSelectCallback}
      onSearch={onSearchCallback}
      placeholder={placeholder}
      isLoading={isLoading}
    />
  )
})
